import './scss/pages/blacklist-main.scss';
import 'tippy.js/dist/tippy.css';
import './js/banners';
import './js/scroll-to-top';
import '../../css/font-awesome.min.css';

/* components */
import Language from './components/language';
import Blacklist from './components/blacklist';
import Comment from './components/comment';
import Scrollspy from './components/scrollspy';
import Banner from './components/banner';
import Sidemenu from './components/sidemenu';
import Form from './components/form';
import Whois from './components/whois';
import tippy from "tippy.js";

tippy('[data-tippy-content]', {
    theme: 'tippy-wrapper',
});
